import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './home/header/header.component';
import { LoginComponent } from 'sce-home';
import { FooterComponent } from './home/footer/footer.component';
import { MenuComponent } from 'sce-home';
import { BreadcrumbComponent } from './home/breadcrumb/breadcrumb.component';
import { ProfileComponent } from './home/profile/profile.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { HomeService } from './home/home.service';
import { LeftPanelContentsComponent } from './home/left-panel-contents/left-panel-contents.component';
import { PrinterSetupComponent } from 'sce-home';
import { LeftPanelService } from './home/services/left-panel.service';
import { UserPreferenceService } from './home/services/user-preference.service';
import { DialogModule, TooltipModule } from 'primeng/primeng';
import { SCEModalComponent, SCEUILibraryModule } from 'sce-ui-lib';
import { ReportsModule } from '../features/reports/reports.module';
import { SCECoreModule } from 'sce-core';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DialogModule,
    SharedModule,
    ReportsModule,
    TooltipModule,
    SCECoreModule,
    SCEUILibraryModule
  ],
  declarations: [
    HomeComponent,
    HeaderComponent,
    LoginComponent,
    FooterComponent,
    MenuComponent,
    BreadcrumbComponent,
    ProfileComponent,
    LeftPanelContentsComponent,
    PrinterSetupComponent
    
  ],
  providers: [
    HomeService,
    UserPreferenceService,
    LeftPanelService
  ],
  entryComponents: [
    SCEModalComponent,
    PrinterSetupComponent
  ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/layout.module.ts